(() => {
const SELECTOR = '[data-scheduled-content]';

function parseBoundary(date, time, offset, endOfDay) {
  const normalizedDate = date?.trim().replaceAll('/', '-');
  if (!normalizedDate) return { value: null, valid: true };
  if (!/^\d{4}-\d{2}-\d{2}$/.test(normalizedDate)) return { value: null, valid: false };

  let normalizedTime = time?.trim() || (endOfDay ? '23:59:59' : '00:00:00');
  if (/^\d{2}:\d{2}$/.test(normalizedTime)) normalizedTime += ':00';
  if (!/^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(normalizedTime)) {
    return { value: null, valid: false };
  }

  let normalizedOffset = offset?.trim() || 'Z';
  if (/^[+-]\d{4}$/.test(normalizedOffset)) {
    normalizedOffset = `${normalizedOffset.slice(0, 3)}:${normalizedOffset.slice(3)}`;
  }
  if (normalizedOffset !== 'Z' && !/^[+-](0\d|1[0-4]):[0-5]\d$/.test(normalizedOffset)) {
    return { value: null, valid: false };
  }

  const value = Date.parse(`${normalizedDate}T${normalizedTime}${normalizedOffset}`);
  return { value: Number.isNaN(value) ? null : value, valid: !Number.isNaN(value) };
}

function updateAnnouncementBar(element) {
  const bar = element.closest('announcement-bar-component');
  if (!bar) return;

  const slides = [...bar.querySelectorAll('slideshow-slide.announcement-bar__slide')];
  const activeSlides = slides.filter((slide) => !slide.hidden);
  if ('current' in bar) bar.current = bar.current;
  const arrows = bar.querySelector('slideshow-arrows');
  if (arrows) arrows.hidden = activeSlides.length <= 1;

  const section = bar.closest('.announcement-bar');
  if (section && slides.length > 0) section.hidden = activeSlides.length === 0;
}

function updateElement(element) {
  if (element.dataset.scheduleEnabled !== 'true') {
    element.hidden = false;
    element.dataset.scheduleState = 'disabled';
    updateAnnouncementBar(element);
    return;
  }

  const start = parseBoundary(
    element.dataset.startDate,
    element.dataset.startTime,
    element.dataset.timezoneOffset,
    false
  );
  const end = parseBoundary(
    element.dataset.endDate,
    element.dataset.endTime,
    element.dataset.timezoneOffset,
    true
  );

  if (!start.valid || !end.valid) {
    element.dataset.scheduleState = 'invalid';
    element.hidden = element.dataset.designMode !== 'true';
    console.warn('Scheduled content: invalid date, time, or timezone value.', element);
    updateAnnouncementBar(element);
    return;
  }

  const now = Date.now();
  const beforeStart = start.value !== null && now < start.value;
  const afterEnd = end.value !== null && now > end.value;
  element.hidden = beforeStart || afterEnd;
  element.dataset.scheduleState = element.hidden ? (beforeStart ? 'before-start' : 'after-end') : 'active';
  updateAnnouncementBar(element);
}

function updateAll(root = document) {
  if (root instanceof Element && root.matches(SELECTOR)) updateElement(root);
  root.querySelectorAll?.(SELECTOR).forEach(updateElement);
}

if (!window.ScheduledContent) {
  window.ScheduledContent = { updateAll };
  updateAll();
  window.setInterval(() => updateAll(), 30000);
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  document.addEventListener('shopify:block:select', (event) => updateAll(event.target));
} else {
  window.ScheduledContent.updateAll();
}
})();
